import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export interface PlanStore {
	username: string
	usersPreferredName: string
	companyId: string
	contractId: string
	memberId: string
	memberSeqNumber: string
	isPolicyHolder: boolean
	isActive: boolean
	contractType: 'Medical' | 'Dental' | 'Vision'
	origEffDate: string
	covTermDate: string
	lobDisplayName: string
	tier1: string
	ssoType: string | null
	displayName: string
	groupNumber: string
	carrierCode: string
}

/** @deprecated Use PlanStore instead */
type IPlanStore = PlanStore

export const useSelectedPlanStore = defineStore(
	'selectedPlanStore',
	() => {
		// ====---------------====
		// 🗄️ State
		// ====---------------====
		const defaultState: PlanStore = {
			username: '',
			usersPreferredName: '',
			companyId: '',
			contractId: '',
			memberId: '',
			memberSeqNumber: '',
			isPolicyHolder: false,
			isActive: false,
			contractType: 'Medical',
			origEffDate: '',
			covTermDate: '',
			lobDisplayName: '',
			tier1: '',
			ssoType: '',
			displayName: '',
			groupNumber: '',
			carrierCode: ''
		}
		const state = reactive<PlanStore>({ ...defaultState })
		const loaded = ref(false)

		// ====---------------====
		// 🏃‍♂️ Getters
		// ====---------------====
		function getStore() {
			return state
		}

		function getLobName() {
			switch (state.tier1) {
				case 'HA':
					return 'Health Advantage '
				case 'BA':
					return 'BlueAdvantage Administrators of Arkansas '
				case 'ABCBS':
					return 'Arkansas Blue Cross and Blue Shield '
				case 'ABM':
					return 'Arkansas Blue Medicare '
				case 'OCTAVE':
					return 'Octave'
				case 'Skai':
					return 'Skai Blue Cross Blue Shield'
				default:
					return 'Arkansas Blue Cross and Blue Shield '
			}
		}

		function isFutureEffective(): boolean {
			if (state.origEffDate) {
				const effDate = new Date(state.origEffDate)
				const today = new Date()

				return effDate > today ? true : false
			} else {
				return false
			}
		}

		function isEffectiveWindow(days: number = 0): boolean {
			if (state.origEffDate) {
				const effDate = new Date(state.origEffDate)
				effDate.setDate(effDate.getDate() + days)
				const today = new Date()
				return effDate > today ? true : false
			} else {
				return false
			}
		}

		// ====---------------====
		// 🎬 Actions
		// ====---------------====
		function setupStore(plan: PlanStore) {
			Object.assign(state, plan)
			loaded.value = true
		}

		function $reset() {
			Object.assign(state, defaultState)
			loaded.value = false
		}

		// ====---------------====
		// 🚀 Exports
		// ====---------------====
		return {
			state,
			loaded,
			getLobName,
			getStore,
			setupStore,
			isFutureEffective,
			isEffectiveWindow,
			$reset
		}
	},
	{
		persist: {
			storage: sessionStorage
		}
	}
)
